import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { siteInfo, categories } from "@/mocks/data";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === "/";

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? "bg-background-50 shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-xl font-bold tracking-tight whitespace-nowrap cursor-pointer"
            style={{ fontFamily: "var(--font-heading)" }}
          >
            <span
              className={`${
                scrolled || !isHome ? "text-foreground-950" : "text-white"
              }`}
            >
              {siteInfo.logo}
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === "/"
                  ? "text-primary-500"
                  : scrolled || !isHome
                  ? "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                  : "text-white/80 hover:text-white hover:bg-white/10"
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.id}`}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === `/category/${cat.id}`
                    ? "text-primary-500"
                    : scrolled || !isHome
                    ? "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                    : "text-white/80 hover:text-white hover:bg-white/10"
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === "/about"
                  ? "text-primary-500"
                  : scrolled || !isHome
                  ? "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                  : "text-white/80 hover:text-white hover:bg-white/10"
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex">
            <a
              href="#"
              className="bg-primary-500 text-white px-5 py-2 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              立即注册
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer ${
              scrolled || !isHome ? "text-foreground-950" : "text-white"
            }`}
            aria-label="菜单"
          >
            <i className={`ri-${mobileOpen ? "close" : "menu"}-line text-xl`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link
              to="/"
              className={`px-4 py-3 rounded-lg text-sm font-medium cursor-pointer ${
                location.pathname === "/"
                  ? "text-primary-500 bg-primary-50"
                  : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.id}`}
                className={`px-4 py-3 rounded-lg text-sm font-medium cursor-pointer ${
                  location.pathname === `/category/${cat.id}`
                    ? "text-primary-500 bg-primary-50"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-3 rounded-lg text-sm font-medium cursor-pointer ${
                location.pathname === "/about"
                  ? "text-primary-500 bg-primary-50"
                  : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              关于我们
            </Link>
            <a
              href="#"
              className="mt-2 bg-primary-500 text-white text-center px-5 py-3 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              立即注册
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}